import { render, staticRenderFns } from "./write-area.vue?vue&type=template&id=0fa949bf&"
import script from "./write-area.vue?vue&type=script&lang=js&"
export * from "./write-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports